// PDF React View
import MessageBox from "components/shared-components/MessageBox";
import ReactPdfViewer from "components/shared-components/ReactPdfViewer";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Button, Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";
import {
  previewPdfRegisterInvoice,
  resetPreviewPdfRegisterInvoice,
} from "store/actions";
const PDFViewModal = props => {
  const { isOpen, toggle, dataViewDocument } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation(["issueInvoice"]);

  const dataFormat = useSelector(state => state.dataFormat);
  const { previewPdfRegisterFile } = dataFormat;
  useEffect(() => {
    if (isOpen) {
      dispatch(previewPdfRegisterInvoice(dataViewDocument.id,'popupType'));
    } else {
      dispatch(resetPreviewPdfRegisterInvoice());
    }
  }, [isOpen]);

  const styleDiv = {
    width: "100%",
    height: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#8080802b",
  };

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        {/* <ModalHeader toggle={toggle}>
          <Label>Bản hiển thị hóa đơn</Label>
        </ModalHeader> */}
        <ModalBody>
          {previewPdfRegisterFile.loading ? (
            <div style={styleDiv}>
              <Spinner color="primary" />
            </div>
          ) : previewPdfRegisterFile.error ? (
            <div style={styleDiv}>
              <MessageBox
                variant="danger"
                classMore="d-sm-flex align-items-center justify-content-center gap-1 font-size-18"
              >
                <i className="bx bxs-error-alt"></i>File không còn tồn tại
              </MessageBox>
            </div>
          ) : (
            <React.Fragment>
              <div>
                {previewPdfRegisterFile.data && (
                  <React.Fragment>
                    <ReactPdfViewer
                      filePdfUrl={previewPdfRegisterFile.data}
                      style={{ height: "75vh" }}
                    />
                  </React.Fragment>
                )}
              </div>
            </React.Fragment>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={!previewPdfRegisterFile.data}
            onClick={() => {
              const link = document.createElement("a");
              link.href = previewPdfRegisterFile.data;
              link.setAttribute("download", "Invoice.pdf");
              document.body.appendChild(link);
              link.click();
            }}
          >
            <i className="bx bx-download label-icon" />
            Download bản hiển thị
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

PDFViewModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dataViewDocument: PropTypes.any,
};

export default PDFViewModal;
